export const generateOptions = (recordQuantity) => {
	const options = [];
	for (let i = 0; i < recordQuantity; i++) {
		options.push({ label: i, value: i });
	}
	return options;
};
